module.exports = __webpack_public_path__ + "static/media/footer_bg.077c9411.png";